import { render } from "./PageSimulation.vue?vue&type=template&id=1cd6ced4&scoped=true"
import script from "./PageSimulation.vue?vue&type=script&lang=js"
export * from "./PageSimulation.vue?vue&type=script&lang=js"

import "./PageSimulation.vue?vue&type=style&index=0&id=1cd6ced4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd6ced4"]])

export default __exports__